/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BlobWithUrl } from './BlobWithUrl';
import {
    BlobWithUrlFromJSON,
    BlobWithUrlFromJSONTyped,
    BlobWithUrlToJSON,
} from './BlobWithUrl';

/**
 * 
 * @export
 * @interface DownloadWithUrlsResponse
 */
export interface DownloadWithUrlsResponse {
    /**
     * 
     * @type {Array<BlobWithUrl>}
     * @memberof DownloadWithUrlsResponse
     */
    blobsWithUrls: Array<BlobWithUrl>;
    /**
     * 
     * @type {string}
     * @memberof DownloadWithUrlsResponse
     */
    error?: string;
}

/**
 * Check if a given object implements the DownloadWithUrlsResponse interface.
 */
export function instanceOfDownloadWithUrlsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "blobsWithUrls" in value;

    return isInstance;
}

export function DownloadWithUrlsResponseFromJSON(json: any): DownloadWithUrlsResponse {
    return DownloadWithUrlsResponseFromJSONTyped(json, false);
}

export function DownloadWithUrlsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DownloadWithUrlsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'blobsWithUrls': ((json['blobs_with_urls'] as Array<any>).map(BlobWithUrlFromJSON)),
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function DownloadWithUrlsResponseToJSON(value?: DownloadWithUrlsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'blobs_with_urls': ((value.blobsWithUrls as Array<any>).map(BlobWithUrlToJSON)),
        'error': value.error,
    };
}

